import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { memberApi } from '@formosa/shared/api/member';
import { formatDateTime } from '@formosa/shared/utils/formatDateTime';
import { resolveMemberMediaUrl } from '@formosa/shared/utils/mediaUrl';
import { resolveNewsApiLang } from '@formosa/shared/utils/newsLang';
import { useTranslation } from '../../i18n/LocaleContext';

export default function NewsDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { locale, t } = useTranslation();
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!id) {
      return undefined;
    }
    let cancelled = false;

    async function load() {
      setLoading(true);
      setError('');
      try {
        const data = await memberApi.newsDetail(id, { lang: resolveNewsApiLang(locale) });
        if (!cancelled) {
          setDetail(data);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message || t('news.loadFailed'));
          setDetail(null);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, [id, locale, t]);

  return (
    <div className="news-detail-page">
      <header className="news-detail-page__header">
        <button
          type="button"
          className="news-detail-page__back"
          aria-label={t('common.back')}
          onClick={() => navigate(-1)}
        >
          ‹
        </button>
      </header>

      <div className="news-detail-page__body">
        {loading ? <p className="news-page-status">{t('common.loading')}</p> : null}
        {error ? <p className="news-page-status news-page-status--error">{error}</p> : null}
        {!loading && !error && detail ? (
          <article className="news-detail">
            <h1 className="news-detail__title">{detail.title}</h1>
            <p className="news-detail__time">{formatDateTime(detail.newsTime)}</p>
            {detail.image ? (
              <img src={resolveMemberMediaUrl(detail.image)} alt="" className="news-detail__image" />
            ) : null}
            <div
              className="news-detail__content"
              dangerouslySetInnerHTML={{ __html: detail.body || '' }}
            />
          </article>
        ) : null}
      </div>
    </div>
  );
}
